import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function FeaturedArticle() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-7 h-[600px] bg-card/40 animate-pulse" />
        <div className="lg:col-span-5 flex flex-col gap-6">
          {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-[160px] bg-card/40 animate-pulse" />)}
        </div>
      </div>;
  }
  if (error || posts.length === 0) {
    return <p className="font-default italic text-muted-foreground">
        No research updates available at this time.
      </p>;
  }
  const featured = posts[0];
  const secondary = posts.slice(1, 4);
  return <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
      {}
      <article data-index={0} className="lg:col-span-7 group relative bg-secondary backdrop-blur-sm border border-border shadow-lg overflow-hidden flex flex-col">
        {featured.featuredImage && <div className="relative w-full overflow-hidden" style={{
        aspectRatio: "16/13"
      }}>
            <img src={featured.featuredImage} alt={featured.title} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]" />
          </div>}
        <div className="flex-1 flex flex-col gap-5 p-8 lg:p-10">
          {featured.categories && featured.categories.length > 0 && <span className="font-mono text-xs uppercase tracking-[0.2em] text-primary">
              RESEARCH / {featured.categories[0].name}
            </span>}
          <Link to={featured.link || "#"} className="block group/title">
            <h3 className="font-default text-2xl md:text-3xl lg:text-[32px] font-bold leading-[1.1] tracking-tight text-white">
              <span className="bg-[length:0%_1px] bg-no-repeat bg-left-bottom transition-[background-size] duration-500 group-hover/title:bg-[length:100%_1px]" style={{
              backgroundImage: `linear-gradient(to right, var(--primary), var(--primary))`
            }}>
                {featured.title}
              </span>
            </h3>
          </Link>
          {featured.excerpt && <p className="font-default text-base md:text-lg leading-relaxed text-muted-foreground line-clamp-2" dangerouslySetInnerHTML={{
          __html: featured.excerpt
        }} />}
          <div className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.15em] text-muted-foreground mt-auto pt-2">
            {featured.author?.name && <span>BY {featured.author.name}</span>}
            <span>·</span>
            <span>8 MIN READ</span>
            {featured.date && <>
                <span>·</span>
                <span>
                  {new Date(featured.date).toLocaleDateString("en-US", {
                month: "long",
                year: "numeric"
              }).toUpperCase()}
                </span>
              </>}
          </div>
        </div>
      </article>

      {}
      <div className="lg:col-span-5 flex flex-col">
        {secondary.map((post, i) => <div key={post.id} data-index={i}>
            <article className="group flex gap-5 bg-secondary backdrop-blur-sm border border-border shadow-md p-5 transition-all duration-300">
              {post.featuredImage && <Link to={post.link || "#"} className="shrink-0 w-[140px] h-[140px] overflow-hidden">
                  <img src={post.featuredImage} alt={post.title} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]" />
                </Link>}
              <div className="flex-1 flex flex-col gap-2 min-w-0">
                {post.categories && post.categories.length > 0 && <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-primary">
                    RESEARCH / {post.categories[0].name}
                  </span>}
                <Link to={post.link || "#"} className="block group/title">
                  <h4 className="font-default text-base md:text-lg font-bold leading-[1.2] tracking-tight text-white line-clamp-3">
                    <span className="bg-[length:0%_1px] bg-no-repeat bg-left-bottom transition-[background-size] duration-500 group-hover/title:bg-[length:100%_1px]" style={{
                  backgroundImage: `linear-gradient(to right, var(--primary), var(--primary))`
                }}>
                      {post.title}
                    </span>
                  </h4>
                </Link>
                <div className="flex flex-wrap items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.15em] text-muted-foreground mt-auto">
                  {post.author?.name && <span>BY {post.author.name}</span>}
                  <span>·</span>
                  <span>5 MIN READ</span>
                </div>
              </div>
            </article>
            {i < secondary.length - 1 && <div className="h-px w-full bg-border" />}
          </div>)}
      </div>
    </div>;
}
export default function Research() {
  const wp_query = new WP_Query({
    post_type: "post",
    per_page: 4,
    orderby: "date",
    order: "desc"
  });
  return;
}